import { render, staticRenderFns } from "./McAlert.vue?vue&type=template&id=94ac1646"
import script from "./McAlert.vue?vue&type=script&lang=js"
export * from "./McAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports